// extracted by mini-css-extract-plugin
export default {"navigation":"cc1LY","navigation__link":"oNxGa"};